export default defineNuxtPlugin({
  name: 'msw',
  async setup() {
    const config = useRuntimeConfig();

    if (!config.public.mock) {
      return;
    }

    try {
      const { createMswWorker } = await import('@@/mocks/browser');
      const worker = createMswWorker();

      await worker.start({
        onUnhandledRequest: 'warn',
      });

      const { getRequestLog, clearRequestLog } =
        await import('@@/mocks/utils/request-log');
      (window as unknown as Record<string, unknown>).__mswRequestLog = {
        get: getRequestLog,
        clear: clearRequestLog,
      };

      useState('msw-worker', () => worker);
    } catch (e) {
      // MSW service worker may fail on deployed environments (Lambda + CloudFront).
      // The Nitro mock-api middleware provides a server-side fallback.
      console.warn('[MSW] Service worker failed to start:', e);
    }
  },
});
